import { render, staticRenderFns } from "./AddParticipant.vue?vue&type=template&id=166b3742&scoped=true"
import script from "./AddParticipant.vue?vue&type=script&lang=js"
export * from "./AddParticipant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "166b3742",
  null
  
)

export default component.exports